import { useEffect, useState } from 'react';
import { Grid, makeStyles } from "@material-ui/core";
//import UtilService from "../../../../../../../helper/service";
//import clsx from 'clsx';
import { useDispatch, useSelector } from "react-redux";
import { getSegmentAsClip, } from '../../../../../../../store/actions/creator/analysis';
//import AnalysisScoreIcon from '../../../../../../atoms/creator/analyzeScoreIcon';
//import LinearProgress from '@material-ui/core/LinearProgress';
//import { Skeleton } from '@material-ui/lab';
//import GraphAreaSection from '../performance/graphArea';

import ImmersionScore from './stats/immersion_score';
import SafetyScore from './stats/safety_score';
import ParticipantCount from './stats/participant_count';
import ParticipantBreakdown from './stats/participant_breakdown';
import BestMoment from './stats/best_moment';
import WorstMoment from './stats/worst_moment';
import ConfidenceScore from './stats/confidence_score';

interface IProps {
  session: any;
  participantsStatus: any;
  immersionData: any;
  thumbnail: any;
  safetyData: any;
  sessionCode: string;
  isMobile: boolean;
  audienceImmersions: any;
  bestMoments: any;
  worstMoments: any;
  participants: any;
  confidenceScore: string;
}

const OverallPerformanceStats = (props: IProps) => {
  const classes = useStyles();
  const { participantsStatus, session, immersionData, safetyData, isMobile, audienceImmersions, bestMoments, worstMoments, participants, confidenceScore } = props;
  //const { sessionOverview, fullLoaded } = useSelector((state: any) => state.creatorExperienceManager);
  //const { stimulus, clipLoaded, identifiers, immersion_overall, safety_overall, cliped, settings, all, excludedParticipants } = useSelector((state: any) => state.analysis);
  const { stimulus, clipLoaded, settings} = useSelector((state: any) => state.analysis);
  const currentSessionCode = localStorage.getItem("session_code") ? localStorage.getItem("session_code") : "";
  //const { pdfLoading } = settings;

  const dispatch = useDispatch();
  const [expLength, setExpLength] = useState<any>('Processing...');
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : ""


if (settings && isMobile) {
//
}




//console.log(`STATS PARTs = ${JSON.stringify(participants)}`)
//console.log(`worst moms = ${JSON.stringify(worstMoments)}`)

/*
  console.log(expLength);
  console.log(participantsStatus);
  console.log(immersionData);
  console.log(safetyData);
  console.log(isMobile);
  console.log(sessionOverview);
  console.log(fullLoaded);
  console.log(pdfLoading);
*/

  /*
  const graphs = all
    .filter((item: any) =>
      !excludedParticipants.includes(item.activeParticipant) &&
      (identifiers.includes(item.activeParticipant) || item.activeParticipant === 'All' || item.isTag)
    )
    .map((item: any) => (cliped ? {
      ...item, immersion: {
        ...item.immersion, data: item.immersion.data.filter((datum: any) => {
          return UtilService.getLocalEpoch2(datum.time_stamp) >= cliped.start_clip && UtilService.getLocalEpoch2(datum.time_stamp) <= cliped.end_clip
        })
      },
    } : item))
    .map((item: any) => (cliped ? {
      ...item, pills: item.pills.filter((datum: any) => {
        return (
          (cliped.start_clip <= datum.start && datum.start <= cliped.end_clip)
          || (cliped.start_clip <= datum.end && datum.end <= cliped.end_clip)
          || (datum.start <= cliped.start_clip && cliped.end_clip <= datum.end)
        )
      })
    } : item))
    .map((item: any) => (cliped ? {
      ...item, safety: item.safety.filter((datum: any) => {
        return datum.epoch_start + 120 >= cliped.start_clip && datum.epoch_start <= cliped.end_clip
      })
    } : item));
*/
  //const isGraphImmersion = graphs.length > 0 && graphs[0]?.immersion?.data.length > 0;
  //const isSafety = UtilService.isShowSafety(session?.session_type, cliped ? cliped.end_clip - cliped.start_clip : session?.session_length);
  //const isGraphSaftey = graphs.length > 0 && graphs[0]?.safety?.length > 0 && (
  //  (currentSessionCode && stimulus && session?.session_type === 'ASYNC') ? session?.session_length > 120 : true);
  //const isGraphAvailable = (session?.session_type === 'ASYNC' || (session?.session_type === 'MODERATED' && session?.session_status === 'COMPLETED'))

  useEffect(() => {
    if (session?.session_length) {
      setExpLength(session?.session_length)
    }
  }, [session]);

  useEffect(() => {
    if (currentSessionCode && stimulus && session?.session_type === 'ASYNC') {
      dispatch(getSegmentAsClip(loginUserData.customer_id, stimulus.stimulus_id))
    }
    if (currentSessionCode && session?.session_type === 'MODERATED') {
      dispatch(getSegmentAsClip(loginUserData.customer_id, currentSessionCode))
    }
  }, [currentSessionCode, clipLoaded, stimulus?.stimulus_id, session]);

  
  
 

  return (
    <div className={classes.root}>
      

      <Grid container id={'statsbox'} direction={'column'} alignContent={'center'} alignItems={'center'} style={{ padding: 15, marginTop: '50px' }}>
      <Grid item xs={10}>
        
        <Grid container direction={'row'} spacing={3} >



        { session && (session.session_type === 'ASYNC' || session.session_type === 'REEL') && 
          <ImmersionScore immersionData={immersionData} />
        }

          <ParticipantBreakdown audienceImmersions={audienceImmersions} />

          <ParticipantCount participantsStatus={participantsStatus} />

          <ConfidenceScore participantsStatus={participantsStatus} participants={participants} confidenceScore={confidenceScore} />
          

          {bestMoments.length >= 1 && 
            <BestMoment bestMoments={bestMoments}/>
          }

          {worstMoments.length >= 1 && 
            <WorstMoment worstMoments={worstMoments}/>
          }

        { session && (session.session_type === 'ASYNC' || session.session_type === 'REEL') && expLength>=300 && 
          <SafetyScore safetyData={safetyData} />
        }
          


        </Grid>

      </Grid>
      </Grid> 




      

      
    </div>
  )
};

export default OverallPerformanceStats;



const useStyles = makeStyles(() => ({
  root: {
    paddingTop: 0,
    '@media (max-width: 600px)': {
      paddingTop: 0,
    },
  },
  sectionTitle: {
    fontSize: 24,
    fontFamily: 'Spartan-bold',
    color: '#697683'
  },
  typeTitle: {
    fontSize: 24,
    fontFamily: 'Spartan-bold',
    color: '#697683',
    textAlign: 'center',
  },
  titleSection: {
    maxWidth: 500,
    display: 'flex',
    alignItems: 'center'
  },
  numberTitle: {
    marginTop: 5,
    fontSize: 29,
    minWidth: 60,
    textAlign: 'center',
    fontFamily: 'Spartan-extrabold',
    padding: '0 15px',
    '@media screen and (max-width: 600px)': {
      fontSize: 30
    }
  },
  title: {
    minWidth: 146,
    marginTop: 5,
    fontSize: 20,
    fontFamily: 'Spartan-bold',
    letterSpacing: '2px',
    textTransform: 'uppercase',
    '@media screen and (min-width: 331px) and (max-width: 600px)': {
      fontSize: 20
    },
    '@media screen and (max-width: 330px)': {
      fontSize: 18
    }
  },
  titleIcon: {
    width: 42,
    height: 42,
    '@media screen and (min-width: 331px) and (max-width: 600px)': {
      width: 35,
      height: 35
    },
    '@media screen and (max-width: 330px)': {
      width: 30,
      height: 30
    }
  },
  cardSection: {
    borderRadius: 20,
    background: '#fff',
    boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)"
  },
  pdfCardSection: {
    borderRadius: 20,
    background: '#fff',
    border: '1px solid rgba(0, 0, 0, 0.1)',
  },
  foo:{},
  content: {
    display: 'flex',
    flexDirection: 'row',
    padding: '20px 20px 10px 20px',
    '@media screen and (max-width: 1150px)': {
      padding: '10px 0 5px 10px'
    },
    '@media screen and (max-width: 1023px)': {
      padding: '20px 20px 10px 20px',
    },
    '@media screen and (max-width: 600px)': {
      padding: '10px 10px 5px 10px'
    },
  },
  zenDescription: {
    minHeight: 25,
    fontSize: 14,
    fontFamily: 'roboto-medium',
    color: '#8192A2',
    lineHeight: '19px',
    marginTop: 40,
    '@media screen and (max-width: 600px)': {
      fontSize: 12
    }
  },
  section: {
    flex: 2
  },
  thumbdiv: {
    flex: 1,
    padding: '8px 20px',
    marginRight: 30,
    '@media screen and (max-width: 1150px)': {
      marginRight: 10,
    },
    '@media screen and (max-width: 600px)': {
      padding: 5,
      marginRight: 0,
      display: 'flex',
      alignItems: 'center'
    },
  },
  upDownArrow: {
    width: 13,
    height: 11
  },
  upDownLabel: {
    fontFamily: 'Spartan-extrabold',
    fontSize: 16,
    paddingLeft: 8,
    paddingRight: 8,
    marginTop: 3
  },
  normsAverageLabel: {
    fontFamily: 'roboto-bold',
    fontSize: 14,
    color: '#212D40'
  },
  scoreDiv: {
    marginTop: 20
  },
  diffDescription: {
    marginTop: 5
  },
  rowCol: {
    display: 'flex',
    flexDirection: 'column',
  },
  rowCenter: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
  },
  categoryTitle: {
    fontSize: 16,
    fontFamily: 'roboto-regular',
    color: '#697683',
    marginTop: 30,
    lineHeight: 1.5,
    marginBottom: 30
  },
  bagIcon: {
    height: 12,
    position: 'absolute',
    top: 21
  },
  graphBar: {
    width: 1,
    height: 15,
    marginLeft: 6,
    background: '#111',
    position: 'absolute',
  }
}));